import React, { forwardRef, useState, useRef, useImperativeHandle } from "react";
import router from "umi/router";
import { PageHeaderWrapper } from "@ant-design/pro-layout";
import ProTable, { IntlProvider, enUSIntl } from "@ant-design/pro-table";
import { Pagination } from "antd";
import SortAndFilter, { DEFAULT_FILTERS } from "@/components/SortAndFilter";
// this tags represent interactive elements on table row
const ignoreTags = [
    "button",
    ".ant-select",
    ".ant-select-selector",
    ".ant-select-dropdown",
    ".ant-dropdown-menu",
    ".ant-modal-wrap",
].join(", ");
export function rowClick(record, baseUrl, parameterName, rowKey, specialRowKey) {
    // Nissan tables are the only ones without onClick
    if (!baseUrl || !parameterName || !rowKey)
        return {};
    return {
        onClick: (event) => {
            const target = event.target;
            const tag = target.closest(ignoreTags);
            if (tag === null) {
                router.push(`${baseUrl}?${parameterName}=${specialRowKey ? record[specialRowKey] : record[rowKey]}`);
            }
        },
    };
}
const ListView = forwardRef(({ filterType, rowKey = "id", columns, request, filterDateRange, baseDetailsUrl, detailsUrlParamName, sortingSeparator, tableStyle, rowSelection, expandable, totalItems, toolBarRender, header, children, filtersChildren, specialRowKey, onFiltersReset, }, ref) => {
    const filtersRef = useRef(null);
    const actionRef = useRef();
    const [filters, setFilters] = useState(null);
    useImperativeHandle(ref, () => ({
        reload: () => {
            actionRef.current?.reload();
        },
        getFilters: () => filtersRef?.current?.getFilters() ?? null,
    }), []);
    return (React.createElement(PageHeaderWrapper, null,
        header,
        React.createElement(SortAndFilter, { ref: filtersRef, type: filterType, columns: columns, filterDateRange: filterDateRange, sortingSeparator: sortingSeparator, onFiltersChange: setFilters, onReset: onFiltersReset }, filtersChildren),
        filters !== null && (
        // @ts-ignore
        React.createElement(IntlProvider, { value: enUSIntl },
            React.createElement(ProTable, { options: false, search: false, rowKey: rowKey, rowClassName: "tableRow", className: "vehiclesTableClickable", actionRef: actionRef, columns: columns, request: request, tableStyle: tableStyle, rowSelection: rowSelection, expandable: expandable, toolBarRender: toolBarRender, onRow: record => rowClick(record, baseDetailsUrl, detailsUrlParamName, rowKey, specialRowKey), params: {
                    filters,
                }, pagination: false }))),
        children,
        React.createElement("div", { style: {
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                backgroundColor: "white",
                paddingRight: "24px",
                paddingBottom: "24px",
            } },
            React.createElement(Pagination, { current: filters?.page ?? DEFAULT_FILTERS.page, pageSize: filters?.pageSize ?? DEFAULT_FILTERS.pageSize, total: totalItems, onChange: (page, pageSize) => {
                    filtersRef.current?.setPaginationFilters({ page, pageSize });
                } }))));
});
ListView.displayName = "ListView";
ListView.defaultProps = {
    filterDateRange: false,
    baseDetailsUrl: null,
    detailsUrlParamName: null,
    sortingSeparator: ":",
    tableStyle: {},
    rowSelection: undefined,
    expandable: undefined,
    toolBarRender: undefined,
    header: undefined,
    filtersChildren: undefined,
    specialRowKey: undefined,
    onFiltersReset: undefined,
};
export default ListView;
